import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { ToastService } from './toast.service';

export interface IMitsError {
  status: string;
  message: string;
  error: Record<string, string[]>;
  surfaced?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(private readonly toastService: ToastService) {}

  /**
   * Converts an Error of Client-Side or Server-Side Type to IMitsError
   * @param error Any Error
   * @returns Converted IMitsError
   */
  convert(error: any) {
    const errorMessage: IMitsError = {} as IMitsError;
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage.message = error.error.message;
    } else {
      // Get server-side error
      errorMessage.status = error.status;
      errorMessage.message = error.message;
      errorMessage.error = error.error;
    }
    return throwError(errorMessage);
  }

  /**
   * Handles an error, logging and show it to the user
   * @param err IMitsError to handle
   */
  handle(err: unknown) {
    console.error(err);
    // Fehler kommen aus ErrorService.convert bzw. als HttpErrorResponse und tragen die IMitsError-Form
    const error = err as IMitsError;
    // Guard against double surfacing: once an error object has been shown to
    // the user, further handle() calls only log it (no second toast).
    if (error.surfaced) {
      return;
    }
    error.surfaced = true;
    if (Number(error.status) === 0) {
      this.toastService.danger(
        $localize`Das Backend ist nicht erreichbar! Bitte melden Sie sich bei Ihrem Administrator`
      );
    } else if (
      Number(error.status) === 401 &&
      error.error &&
      (error.error as any).error === 'No JWT token provided'
    ) {
      window.location.reload();
    } else {
      const errStr =
        'Error:' +
        (error.status ? 'with code [' + error.status + ']:' : ':') +
        error.error[0];
      this.toastService.danger(errStr);
    }
  }
}
